module.exports = __webpack_public_path__ + "img/PerformDash-Activate-Header.53a284a6.svg";